var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.12h24c1.105 0 2 .873 2 1.95v17.552c0 1.077-.895 1.95-2 1.95H12c-1.105 0-2-.873-2-1.95V6.07c0-1.077.895-1.95 2-1.95Zm3 5.85c-.552 0-1 .437-1 .975 0 .54.448.976 1 .976h12c.552 0 1-.437 1-.976a.988.988 0 0 0-1-.975H15Zm0 3.9c-.552 0-1 .438-1 .976 0 .539.448.975 1 .975h6c.552 0 1-.436 1-.975a.988.988 0 0 0-1-.975h-6Z",
    fill: "#edccd0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.585 13.038 24 24.598l16.414-11.56a1.017 1.017 0 0 1 1.397.22c.123.166.189.365.189.57v19.546c0 2.154-1.79 3.9-4 3.9H10c-2.21 0-4-1.746-4-3.9V13.828a.988.988 0 0 1 1-.975c.21 0 .415.065.585.185Z",
    fill: "#F66565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.519ddb53.svg";
export { ForwardRef as ReactComponent };